// extracted by mini-css-extract-plugin
export var label = "_dl-1";
export var reminder = "_dl-0";